export const questionSelect = [
    {
        name: 'Deposit',
        translate: 'deposit',
        id: 1
    },
    {
        name: 'Withdraw',
        translate: 'withdraw',
        id: 2
    },
    {
        name: 'Bets',
        translate: 'bets',
        id: 3
    },
    {
        name: 'Free Fuel',
        translate: 'freeFuel',
        id: 4
    },
    {
        name: 'Promo codes',
        translate: 'promoCodes',
        id: 5
    },
    {
        name: 'Other',
        translate: 'other',
        id: 6
    }
]

export const langSelect = [
    {
        data: 'en',
        name: 'English',
        id: 1
    },
    {
        data: 'ru',
        name: 'Русский',
        id: 2
    }
]

export const orderSelect = [
    {
        data: 'default',
        // subdata: 'desc',
        translate: 'default',
        id: 4
    },
    {
        data: 'price',
        subdata: 'desc',
        translate: 'highPrice',
        id: 1
    },
    {
        data: 'price',
        subdata: 'asc',
        translate: 'lowerPrice',
        id: 2
    },
    {
        data: 'discount',
        icon: true,
        translate: 'bestDeals',
        id: 3
    }
]